/* Copyright (c) 2018 Scaper */

export const Logger = {
    error: (message: string, ...optionalParams: any[]) => console.error(message, ...optionalParams),
};
